import { FC } from "react";
import { Button, Heading, Text } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";

interface Props {
  resetError: () => void;
}

// Rendered by the top-level Sentry ErrorBoundary when a descendant throws —
// most often an effect-cleanup error during a route transition. Without a
// fallback the boundary renders nothing, which blanks the entire app; this
// gives users a themed recovery surface instead. `resetError` clears the
// boundary and re-renders the app at the current route, recovering transient
// unmount-time failures without a full page reload.
export const AppErrorFallback: FC<Props> = ({ resetError }) => (
  <FullBleedSection bgColor="bg-main" gap={6} h="100vh" role="alert">
    <Heading textAlign="center" variant="th-h4">
      Something went wrong
    </Heading>
    <Text maxW="28rem" textAlign="center" variant="th-body2">
      We hit an unexpected error. Tap below to pick up where you left off.
    </Text>
    <Button onClick={resetError} size="th-md">
      Try again
    </Button>
  </FullBleedSection>
);
